function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// @ts-nocheck
import { Component } from "react";
import { Callout } from "@blueprintjs/core";
import h from "@macrostrat/hyper";

function ErrorCallout(props) {
  var _ref, _props$description;

  var error = props.error,
      _props$title = props.title,
      title = _props$title === void 0 ? "Unknown error" : _props$title;
  return h(Callout, {
    title: title,
    icon: "error",
    intent: "danger"
  }, h("p", null, (_ref = (_props$description = props.description) !== null && _props$description !== void 0 ? _props$description : error === null || error === void 0 ? void 0 : error.toString()) !== null && _ref !== void 0 ? _ref : "No description available"));
}

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      error: null
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      var _this$props$onCatch, _this$props;

      // You can also log the error to an error reporting service
      console.log(error);
      (_this$props$onCatch = (_this$props = this.props).onCatch) === null || _this$props$onCatch === void 0 ? void 0 : _this$props$onCatch.call(_this$props, error, info);
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.state.error;
      var _this$props$override = this.props.override,
          override = _this$props$override === void 0 ? false : _this$props$override;

      if (error != null || override) {
        var _ref2, _this$props$descripti, _this$props$title;

        if (this.props.fallback != null) return this.props.fallback; // You can render any custom fallback UI

        return h(ErrorCallout, {
          error: error,
          description: (_ref2 = (_this$props$descripti = this.props.description) !== null && _this$props$descripti !== void 0 ? _this$props$descripti : error === null || error === void 0 ? void 0 : error.toString()) !== null && _ref2 !== void 0 ? _ref2 : "No description available",
          title: (_this$props$title = this.props.title) !== null && _this$props$title !== void 0 ? _this$props$title : "A rendering error has occured"
        });
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return {
        error: error
      };
    }
  }]);

  return ErrorBoundary;
}(Component);

export { ErrorBoundary, ErrorCallout };